!function() {
  "use strict";
  customElements.get("quantity-selector") || customElements.define("quantity-selector", class extends HTMLElement {
    constructor() {
      super(), this.input = this.querySelector('[type="number"]');
    }
    connectedCallback() {
      this.input && this.addEventListeners();
    }
    addEventListeners() {
      this.querySelectorAll("button").forEach((button => {
        button.addEventListener("click", (event => {
          event.preventDefault();
          let quantity = this.input.value;
          switch (button.name) {
           case "plus":
            this.input.stepUp();
            break;

           case "minus":
            this.input.stepDown();
          }
          quantity !== this.input.value && this.input.dispatchEvent(new Event("change", {
            bubbles: !0
          }));
        }));
      }));
    }
  });
}();